import React from 'react';

const EditHeader = ({ data }) => {
    return (
        <div>
            <div className="pt-3 d-none d-lg-block">
                <div className="d-flex justify-content-between align-items-center">
                    <h2 className='fs-5 fw-bold'>Edit Vendor Items</h2>
                    {
                        data.date && <h2 className='fs-5 fw-bold'>{new Date(data.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</h2>
                    }
                </div>
            </div>

            <div className="px-2 d-lg-none">
                <div className="d-flex justify-content-between align-items-center">
                    <h2 className='fs-6 fw-bold'>Edit Items</h2>
                    {
                        data.date && <h2 className='fs-6 fw-bold'>{new Date(data.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</h2>
                    }
                </div>
            </div>
        </div>
    );
};

export default EditHeader;